import * as React from 'react';
import Button from '@mui/material/Button';
import cn from 'classnames';

import { useTheme } from '../../../../theme';
import { CloseButtonProps } from '../../types';
import { CdnIcon } from '@shared/ui';

const CloseButton: React.FC<CloseButtonProps> = ({
	classes,
	variant = 'closePopup',
	disableElevation = true,
	...restProps
}) => {
	const { CloseButton: theme } = useTheme('BaseComponents');

	return (
		<Button
			variant="contained"
			classes={{
				...classes,
				root: cn(theme[variant], classes?.root)
			}}
			disableElevation={disableElevation}
			{...restProps}
		>
			<CdnIcon className={theme.closeIcon} icon="Action/Close-Clear" />
		</Button>
	);
};

export default CloseButton;
